var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    class: _vm.$style.divider,
    style: {
      margin: "".concat(_vm.marginY, "px ").concat(_vm.marginX, "px")
    }
  });
}
var staticRenderFns = []

export { render, staticRenderFns }